import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[horizontalScroll]'
})
export class HorizontalScrollDirective {

  constructor(private el: ElementRef) { }
  isScrolling = false;
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    const container = this.el.nativeElement as HTMLElement;
    const direction = event.deltaY * 2 > 0 ? 1 : -1;
    const end = container.scrollLeft < (container.scrollWidth-container.clientWidth);
    const start = container.scrollLeft == 0;
    if(container.scrollWidth > container.clientWidth && ((direction > 0 && end) || (direction < 0 && !start))){
      event.preventDefault();
    }
    if(!this.isScrolling){
      this.smoothScroll(container, direction*300);
    }

  }
  smoothScroll(element: HTMLElement, scrollAmount: number, duration = 300, delay = 25) {
    this.isScrolling = true;
    const startTime = performance.now();
    const startScrollLeft = element.scrollLeft;

    const animateScroll = () => {
      const currentTime = performance.now();
      const elapsedTime = currentTime - startTime;
      if (elapsedTime < delay) {
        requestAnimationFrame(animateScroll);
        return;
      }
      const progress = Math.min((elapsedTime - delay) / duration, 1);
      const easedProgress = this.easeInOutQuad(progress);
      const newScrollLeft = startScrollLeft + scrollAmount * easedProgress;
      element.scrollLeft = newScrollLeft;
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        this.isScrolling = false;
      }
    };

    animateScroll();
  }

  private easeInOutQuad(t: number) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
}
